import { notification } from "antd";

const handleInternalServerError = () => {
    notification['error']({
        message: 'Instabilidades no serviço',
        description: 'Tente novamente mais tarde'
    })
}

export default handleInternalServerError;